import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        config: {
            baseUrlApi: process.env.VUE_APP_BASE_URL,  
        },
        user: {
            token: '',
            aluno_nome: '',
            turma_id: '',
            turma_nome: '',
            permissoes: {},
        },
        loading: true,
        
    },
    actions: { },
    mutations: {        
        setToken(state, value){

            state.user.token = value.token;
            state.user.aluno_nome= value.aluno_nome;
            state.user.turma_id= value.turma_id;
            state.user.turma_nome= value.turma_nome;
            state.user.permissoes = value.permissoes || {};
        },
        setPermissoes(state, value){

            state.user.permissoes = value || {};
            // Persiste no blob do token para sobreviver a reloads (o layout reidrata daqui).
            try {
                const blob = JSON.parse(localStorage.getItem('pa85726549Token') || '{}');
                blob.permissoes = state.user.permissoes;
                localStorage.setItem('pa85726549Token', JSON.stringify(blob));
            } catch (e) { /* ignora */ }
        },
        updateLoading(state, value){

            state.user.loading = value;
        },
        logout(state, value){

            state.user.token = '';
            state.user.aluno_nome = '';
            state.user.turma_id = '';
            state.user.turma_nome = '';
            state.user.permissoes = {};
            state.user.loading = true;
            localStorage.removeItem('pa85726549Token');
            window.eventBus = new Vue();
            router.push('/').catch(err => { })
        },
        throwException(state, value) {

            console.log(String(value));
        }
    },
    getters: {
        // Permissões do módulo do aluno com defaults aplicados (chave ausente = habilitada).
        // O enforcement real é no backend; aqui é só para esconder menu/abas/botões.
        permissoes: state => {
            const p = state.user.permissoes || {}
            return {
                ver_notas:       p.ver_notas       !== false,
                ver_parecer:     p.ver_parecer     !== false,
                baixar_material: p.baixar_material !== false,
                enviar_material: p.enviar_material !== false,
                // BLOCO L — item 109. A chave faltava aqui: o getter monta um objeto novo,
                // então `ver_acompanhamento` chegava sempre `undefined` ao layout e o item
                // de menu nunca era incluído, mesmo com o backend liberando o módulo.
                ver_acompanhamento: p.ver_acompanhamento !== false
            }
        },
        getHeader: state => {

            let header = {
                'Content-Type': 'application/json',
                'Accept' : 'application/json'
            }
            return header;
        },
        getHeaderAuth: state => {

            let token = '';
            if(localStorage.getItem("pa85726549Token")) {
                token = JSON.parse(localStorage.getItem("pa85726549Token")).token
            }

            let options = {

                headers : {
                    'Content-Type' : 'application/json',
                    'Accept' : 'application/json',
                    'Authorization' : token
                }

            }
            return options;
        },
        getHeaderAuthExcel: state => {

            let options = {

                'responseType': 'blob',

                headers : {

                    'Authorization' : `${state.user.token}`
                }

            }
            return options;
        },
        getHeaderFileAuth: state => {

            let options = {

                headers : {
                    'Content-Type' : ['application/json', 'multipart/form-data'],
                    'Accept' : 'application/json',
                    'Authorization' : `${state.user.token}`
                }

            }
            return options;
        },
    }
})